const getPageData = (data) => {
  return {
    referringSite: document.referrer,
    language: 'english',
    experienceType: 'desktop',
    is404: false,
    name: data.page, // Refer Taxonomy Table (Column: “Page Level Content”).
    sitesection1: 'secure',
    sitesection2: 'wellness',
    sitesection3: 'community resources',
    sitesection4: '',
    test: '',
    group: data.group, // examples: product, search, content
  };
};
const getUserData = (data) => {
  return {
    loginStatus: 'logged in',
    userType: `member>${data.lob}`,
    groupId: '',
    carrierId: '',
    hsid: '',
    rallyId: '',
    patientId: '', // This value is required to be encrypted. If you do not encrypt it, the value is PII and you will be accountable for passing it. See encryption logic in the linked document below.
    payerGroup: data.lob,
    memberId: '',
  };
};

const getUserId = (data) => {
  return {
    userId: data.userId,
  };
};

const getLinkData = (data) => {
  return {
    name: data.name, // Ex: "Go to My Activity", “helping you find resources:take quiz” based on UI value.
    location: data.location, // Ex: "browse common category section", “get matched resources”, “faq section” - Based on UI Link Location (Section/Body Content)
    type: 'internal', // Ex: "internal" || "external" based on link functionality.
    destinationUrl: data.destination, // leave blank when link does not point to a URL
  };
};
const getSearchData = (data) => {
  return {
    term: data.term, // Ex: “all emergency”, “temporary shelter”
    type: 'community search', // Ex: “community search”, “site”
    filters: [], // if filters are applied; for multiple values separate them with a "|" delimiter
    results: '', // set to "zero" if 0 search results are returned
    method: 'typed', // Ex: typed, autofill
  };
};
const getFormStartData = (data) => {
  return {
    name: data.name, // Ex: “get all the benefits you deserve”, “helping you find resources”
  };
};
const getFormEnd = (data) => {
  return {
    name: data.name, // Ex: “get all the benefits you deserve”, “helping you find resources” };
  };
};
export const adobeTags = {
  PAGE_LOAD: (data) => {
    return {
      event: 'page track',
      data: {
        page: { ...getPageData(data) },
        user: { ...getUserData(data) },
      },
    };
  },
  LINK_LOAD: (data) => {
    return {
      event: 'link track',
      data: {
        link: { ...getLinkData(data) },
      },
    };
  },
  SEARCH_LOAD: (data) => {
    return {
      event: 'standard search',
      data: {
        search: { ...getSearchData(data) },
      },
    };
  },
  FORM_START_LOAD: (data) => {
    return {
      event: 'form started',
      data: {
        form: { ...getFormStartData(data) },
      },
    };
  },
  FORM_END_LOAD: (data) => {
    return {
      event: 'form complete',
      data: {
        form: { ...getFormEnd(data) },
      },
    };
  },
  EMAIL_CLICK: (data) => {
    return {
      event: 'email clicked',
      data: {
        user: { ...getUserId(data) },
      },
    };
  },
};
